export function toCompanyKey(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export const COMPANY_DETAIL_CONFIG = {
  adidas: {
    title: "adidas",
    subtitle: "ls company/adidas/",
    storageKey: "companyDetail:adidas:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "digitale produkte und trainingsnahe workflows im markenumfeld." },
      { type: "response", text: "fokus: klare umsetzung, teamfaehige standards und verstaendliche loesungen." },
      { type: "status", text: "bereit fuer case-review -> Saghallo" },
    ],
  },
  volvo: {
    title: "Volvo",
    subtitle: "ls company/volvo/",
    storageKey: "companyDetail:volvo:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "technische konzepte und trainingsprozesse fuer komplexe produktwelten." },
      { type: "response", text: "fokus: robustheit, wartbarkeit und schnelle team-einarbeitung." },
      { type: "status", text: "bereit fuer projektgespraech -> Saghallo" },
    ],
  },
  "stadt-hamburg": {
    title: "Stadt Hamburg",
    subtitle: "ls company/hamburg/",
    storageKey: "companyDetail:hamburg:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "digitale umsetzung mit hohem anspruch an klarheit und nachhaltigkeit." },
      { type: "response", text: "fokus: verstaendliche architektur und stabile alltagsprozesse." },
      { type: "status", text: "bereit fuer architektur-check -> Saghallo" },
    ],
  },
  basf: {
    title: "BASF",
    subtitle: "ls company/basf/",
    storageKey: "companyDetail:basf:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "praxisnahe software- und trainingseinsaetze im enterprise-umfeld." },
      { type: "response", text: "fokus: team-enablement, klare handoffs und saubere technische linie." },
      { type: "status", text: "bereit fuer technische einordnung -> Saghallo" },
    ],
  },
  siemens: {
    title: "Siemens",
    subtitle: "ls company/siemens/",
    storageKey: "companyDetail:siemens:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "engineering-nahe loesungen fuer teams mit hoher fachlicher tiefe." },
      { type: "response", text: "fokus: struktur, performanz und nachvollziehbare entscheidungen." },
      { type: "status", text: "bereit fuer sparring -> Saghallo" },
    ],
  },
  telekom: {
    title: "Telekom",
    subtitle: "ls company/telekom/",
    storageKey: "companyDetail:telekom:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "skalierbare digitale services und saubere integrative umsetzung." },
      { type: "response", text: "fokus: klare user-fuehrung und belastbare technische basis." },
      { type: "status", text: "bereit fuer service-review -> Saghallo" },
    ],
  },
  "otto-group": {
    title: "Otto Group",
    subtitle: "ls company/otto-group/",
    storageKey: "companyDetail:otto:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "digitale produktentwicklung mit blick auf teamfluss und delivery." },
      { type: "response", text: "fokus: wartbare codebasis und verstaendliche komponentenstruktur." },
      { type: "status", text: "bereit fuer produktive umsetzung -> Saghallo" },
    ],
  },
  "hapag-lloyd": {
    title: "Hapag-Lloyd",
    subtitle: "ls company/hapag-lloyd/",
    storageKey: "companyDetail:hapag:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "prozessstarke software- und trainingsarbeit in komplexen systemen." },
      { type: "response", text: "fokus: transparente technik und sichere team-adaption." },
      { type: "status", text: "bereit fuer workflow-beratung -> Saghallo" },
    ],
  },
  bayer: {
    title: "Bayer",
    subtitle: "ls company/bayer/",
    storageKey: "companyDetail:bayer:typed:v1",
    lines: [
      { type: "prompt", text: "cat context.md" },
      { type: "response", text: "praxisorientierte software- und enablement-projekte mit klarer linie." },
      { type: "response", text: "fokus: technische qualitaet, verstaendnis und nachhaltiger impact." },
      { type: "status", text: "bereit fuer erstgespraech -> Saghallo" },
    ],
  },
};
